import { render, staticRenderFns } from "./submission-card.vue?vue&type=template&id=c97aa9cc&scoped=true&"
import script from "./submission-card.vue?vue&type=script&lang=js&"
export * from "./submission-card.vue?vue&type=script&lang=js&"
import style0 from "./submission-card.vue?vue&type=style&index=0&id=c97aa9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97aa9cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VIcon,VRow,VSelect,VSpacer})
